const deliveries = [
  {
    "code": "2000",
    "distance": 9.087,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2001",
    "distance": 6.314,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2004",
    "distance": 7.617,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2006",
    "distance": 9.369,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2007",
    "distance": 8.635,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2008",
    "distance": 7.676,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2009",
    "distance": 10.647,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2010",
    "distance": 6.748,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2011",
    "distance": 8.998,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2012",
    "distance": 36.169,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2015",
    "distance": 7.53,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2016",
    "distance": 6.467,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2017",
    "distance": 5.819,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2018",
    "distance": 6.389,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2019",
    "distance": 8.849,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2020",
    "distance": 9.744,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2021",
    "distance": 6.775,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2022",
    "distance": 3.771,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2023",
    "distance": 5.848,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2024",
    "distance": 3.601,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2025",
    "distance": 5.442,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2026",
    "distance": 4.96,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2027",
    "distance": 7.615,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2028",
    "distance": 6.351,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2029",
    "distance": 7.669,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2030",
    "distance": 10.146,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2031",
    "distance": 2.23,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2032",
    "distance": 3.245,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2033",
    "distance": 6.53,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2034",
    "distance": 2.366,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2035",
    "distance": 5.387,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2036",
    "distance": 7.564,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2037",
    "distance": 9.365,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2038",
    "distance": 11.731,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2039",
    "distance": 12.667,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2040",
    "distance": 13.095,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2041",
    "distance": 13.837,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2042",
    "distance": 8.805,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2043",
    "distance": 7.662,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2044",
    "distance": 9.339,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2045",
    "distance": 16.987,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2046",
    "distance": 17.742,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2047",
    "distance": 14.878,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2048",
    "distance": 11.033,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2049",
    "distance": 11.661,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2050",
    "distance": 9.893,
    "day": "daily",
    "price": 15
  },
  {
    "code": "2052",
    "distance": 15.115,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2057",
    "distance": 18.656,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2059",
    "distance": 12.758,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2060",
    "distance": 13.114,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2061",
    "distance": 13.626,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2062",
    "distance": 14.081,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2063",
    "distance": 15.725,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2064",
    "distance": 16.677,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2065",
    "distance": 15.009,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2066",
    "distance": 20.179,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2067",
    "distance": 19.532,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2068",
    "distance": 17.695,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2069",
    "distance": 19.444,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2070",
    "distance": 21.664,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2071",
    "distance": 23.441,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2072",
    "distance": 27.403,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2073",
    "distance": 25.697,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2074",
    "distance": 32.849,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2075",
    "distance": 28.072,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2076",
    "distance": 32.817,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2077",
    "distance": 37.906,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2079",
    "distance": 39.508,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2080",
    "distance": 42.087,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2081",
    "distance": 45.387,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2082",
    "distance": 47.13,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2084",
    "distance": 33.031,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2085",
    "distance": 27.772,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2086",
    "distance": 24.289,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2087",
    "distance": 23.824,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2088",
    "distance": 14.637,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2089",
    "distance": 14.332,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2090",
    "distance": 13.987,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2092",
    "distance": 19.338,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2093",
    "distance": 20.565,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2094",
    "distance": 21.34,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2095",
    "distance": 22.672,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2096",
    "distance": 24.571,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2097",
    "distance": 28.907,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2099",
    "distance": 27.64,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2100",
    "distance": 23.526,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2101",
    "distance": 32.169,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2102",
    "distance": 37.841,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2103",
    "distance": 39.91,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2104",
    "distance": 41.711,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2105",
    "distance": 41.109,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2106",
    "distance": 41.659,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2107",
    "distance": 46.317,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2108",
    "distance": 45.001,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2109",
    "distance": 26.163,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2110",
    "distance": 15.175,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2111",
    "distance": 19.01,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2112",
    "distance": 22.903,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2113",
    "distance": 22.234,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2114",
    "distance": 24.015,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2115",
    "distance": 28.8,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2116",
    "distance": 30.114,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2117",
    "distance": 30.975,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2118",
    "distance": 34.442,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2119",
    "distance": 30.748,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2120",
    "distance": 35.159,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2121",
    "distance": 29.477,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2122",
    "distance": 26.434,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2123",
    "distance": 30.27,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2124",
    "distance": 30.27,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2125",
    "distance": 35.831,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2126",
    "distance": 36.9,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2127",
    "distance": 26.427,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2128",
    "distance": 25.535,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2129",
    "distance": 32.382,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2130",
    "distance": 13.154,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2131",
    "distance": 17.311,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2132",
    "distance": 17.311,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2133",
    "distance": 19.383,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2134",
    "distance": 19.776,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2135",
    "distance": 19.022,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2136",
    "distance": 19.638,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2137",
    "distance": 21.435,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2138",
    "distance": 24.986,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2139",
    "distance": 18.809,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2140",
    "distance": 21.052,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2141",
    "distance": 24.77,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2142",
    "distance": 27.442,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2143",
    "distance": 29.343,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2144",
    "distance": 26.111,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2145",
    "distance": 33.604,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2146",
    "distance": 36.799,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2147",
    "distance": 39.844,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2148",
    "distance": 41.063,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2150",
    "distance": 29.9,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2151",
    "distance": 34.249,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2152",
    "distance": 35.523,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2153",
    "distance": 40.294,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2154",
    "distance": 38.657,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2155",
    "distance": 50.452,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2156",
    "distance": 49.422,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2157",
    "distance": 51.447,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2158",
    "distance": 42.579,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2159",
    "distance": 59.614,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2160",
    "distance": 31.477,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2161",
    "distance": 33.814,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2162",
    "distance": 31.51,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2163",
    "distance": 34.51,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2164",
    "distance": 40.594,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2165",
    "distance": 37.669,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2166",
    "distance": 37.58,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2167",
    "distance": 38.5,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2168",
    "distance": 39.987,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2170",
    "distance": 34.927,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2171",
    "distance": 43.471,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2172",
    "distance": 37.684,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2173",
    "distance": 35.858,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2174",
    "distance": 41.424,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2175",
    "distance": 48.63,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2176",
    "distance": 44.083,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2177",
    "distance": 41.572,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2178",
    "distance": 54.951,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2179",
    "distance": 47.17,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2190",
    "distance": 24.677,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2191",
    "distance": 21.935,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2192",
    "distance": 20.919,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2193",
    "distance": 14.62,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2194",
    "distance": 21.322,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2195",
    "distance": 21.729,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2196",
    "distance": 21.514,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2197",
    "distance": 30.899,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2198",
    "distance": 30.071,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2199",
    "distance": 29.013,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2200",
    "distance": 26.364,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2203",
    "distance": 12.539,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2204",
    "distance": 10.797,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2205",
    "distance": 13.833,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2206",
    "distance": 13.944,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2207",
    "distance": 16.647,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2208",
    "distance": 20.809,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2209",
    "distance": 19.071,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2210",
    "distance": 23.248,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2211",
    "distance": 24.011,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2212",
    "distance": 25.451,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2213",
    "distance": 37.484,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2214",
    "distance": 28.398,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2216",
    "distance": 12.913,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2217",
    "distance": 14.047,
    "day": "daily",
    "price": 20
  },
  {
    "code": "2218",
    "distance": 18.103,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2219",
    "distance": 17.291,
    "day": "daily",
    "price": 25
  },
  {
    "code": "2220",
    "distance": 22.085,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2221",
    "distance": 20.05,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2222",
    "distance": 21.903,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2223",
    "distance": 24.619,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2224",
    "distance": 22.864,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2225",
    "distance": 28.856,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2226",
    "distance": 28.384,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2227",
    "distance": 26.56,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2228",
    "distance": 24.369,
    "day": "extended",
    "price": 30
  },
  {
    "code": "2229",
    "distance": 28.276,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2230",
    "distance": 26.685,
    "day": "extended",
    "price": 40
  },
  {
    "code": "2231",
    "distance": 34.237,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2232",
    "distance": 45.659,
    "day": "extended",
    "price": 50
  },
  {
    "code": "2233",
    "distance": 36.453,
    "day": "extended",
    "price": 45
  },
  {
    "code": "2234",
    "distance": 39.048,
    "day": "extended",
    "price": 45
  }
];